// extracted by mini-css-extract-plugin
module.exports = {"all":"Loading_all__3JpSG","load":"Loading_load__22_3Q","gif":"Loading_gif__31rPQ"};